import { SelectorOption } from "../../../shared/components/filtering/filter.interfaces";
import { SelectorOptionsService } from "../../../shared/components/filtering/selector-options.service";
import { Page } from "../../shared/domain/models/page";

export class GetCreatorOptionsByIdsInteractor {
  constructor(
    private readonly selectorOptionsService: SelectorOptionsService,
  ) {}

  public async execute(ids: number[]): Promise<Page<SelectorOption>> {
    const filteredIds = ids.map((id) => +id).filter((id) => !isNaN(+id));
    if (!filteredIds.length) {
      return Page.createWith([]);
    }

    return this.selectorOptionsService.getCreatorsByIds(filteredIds);
  }
}
